exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-typeahead .cursor-pointer {\n  cursor: pointer; }\n\n.custom-typeahead .saved-item i {\n  color: #ff6838; }\n\n.custom-typeahead .input-style {\n  display: block;\n  width: 100%;\n  background-color: #fff;\n  border: 1px solid #ebedf2;\n  border-radius: 4px;\n  outline: 0;\n  box-shadow: 0;\n  box-shadow: none;\n  font-weight: 400;\n  font-size: 13px;\n  margin-bottom: 20px;\n  color: #74788d;\n  line-height: normal;\n  padding: 13px 10px 13px 10px; }\n\n.custom-typeahead .list-location {\n  position: absolute;\n  z-index: 100; }\n\n.custom-typeahead .saved_loc_name {\n  display: block; }\n\n.custom-typeahead .saved-item i {\n  margin-right: 10px; }\n\n.custom-typeahead .loc-saved {\n  display: inline-block; }\n\n.custom-typeahead .loc-sec {\n  font-size: 13px;\n  color: #74788d; }\n\n.custom-typeahead .list-location {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/shared/components/location-typeahead/location-typeahead.component.scss
// module id = ../../../../../src/app/shared/components/location-typeahead/location-typeahead.component.scss
// module chunks = main